import {dateTime} from "services/date";
import {Feedback} from "types/Feedback";
import deserializeEvent from "./event";
import deserializeExhibit from "./exhibit";
import {FeedbackSubjectType} from "../../../types/FeedbackSubjectType";
import deserializeTrail from "./trail";

/**
 * Transform the given feedback by deserializing object properties
 *
 * @internal
 * @param feedback
 */
export default function deserializeFeedback(feedback: any): Feedback {
    feedback.created_at = dateTime(feedback.created_at)
    feedback.updated_at = dateTime(feedback.updated_at)

    switch(feedback.subject_type as FeedbackSubjectType) {
        case FeedbackSubjectType.EVENT:
            feedback.subject = feedback.subject? deserializeEvent(feedback.subject): undefined;
            break;

        case FeedbackSubjectType.EXHIBIT:
            feedback.subject = feedback.subject? deserializeExhibit(feedback.subject): undefined;
            break;

        case FeedbackSubjectType.TRAIL:
            feedback.subject = feedback.subject? deserializeTrail(feedback.subject): undefined;
            break;
    }

    return feedback;
}